import Model from './Model'
export default class Holiday extends Model {

    resource()
    {
        return 'holidays'
    }

    get friendlyType() {
        let response = this.types.find(type => type.id === this.type)
        return response ? response.text : '?'
    }

    get types() {
        return [{
            id: 'vacation',
            text: 'Concediu de odihna'
        },{
            id: 'sick',
            text: 'Concediu medical'
        },{
            id: 'special',
            text: 'Concediu special'
        }]
    }
}
